import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { removeVote, setCategories, submitVoted } from "../actions/cartActions";
import { animated, useSpring, useTrail } from "react-spring";
import {
  ResponsiveContext,
  Box,
  Button,
  CheckBox,
  FormField,
  Heading,
  Image,
  Select,
  TextInput,
  Tip,
} from "grommet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faTimesCircle,
  faCog,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import _ from "lodash";
import { scrollToID } from "../utils/Misc";
import useWindowSize from "../utils/WindowSize";
import Cookies from "universal-cookie";
import API from "../api";
import Settings from "../constants/Settings";
import ReCAPTCHA from "react-google-recaptcha";
import Analytics from "../utils/Analytics";
import LanguageTools from "../utils/LanguageTools";
// End imports

const VoteForm = (props) => {
  const { t, i18n } = props;
  const [errors, setErrors] = useState({}); // Open voting
  const [submissionError, setSubmissionError] = useState(false); // show something went wrong error
  const [submissionErrors, setSubmissionErrors] = useState(false); // Holds submission errors from server reply
  const [votingClosed, setVotingClosed] = useState(false); // show something went wrong error
  const [countrySearch, setCountrySearch] = useState([]);
  const [recaptcha, setRecaptcha] = useState(false); // set form to valid when recaptcha filled in
  const [reloadingSweepstakesInfo, setReloadingSweepstakesInfo] = useState(false); // Used to trigger re-render and reload of sweepstakes info when country changes
  const [sweepstakesText, setSweepstakesText] = useState(""); // Holds sweepstakes text which can change based on country selection
  const [reloadingTerms, setReloadingTerms] = useState(false); // Used to trigger re-render and reload of terms and conditions when country changes
  const [termsText, setTermsText] = useState(""); // Holds terms and conditions text which can change based on country selection
  const SettingsDynamic = useSelector((state) => state.settings);
  const recaptchaRef = React.useRef();
  const countrySearchTimeoutRef = useRef(null);
  const [formData, setFormData] = useState({
    firstName: "",
    secondName: "",
    email: "",
    country: { lab: t("select your country"), value: "" },
    state: "",
    enterSweepstake: false,
    emailOptIn: false,
    agreeTerms: false,
    ballot: {},
    recaptcha: false,
  });
  const screenSize = useContext(ResponsiveContext);

  /** On first load, try and guess users country from current locale **/
  useEffect(() => {
    let localeCountry = i18n.language.split("-")[1];
    if (localeCountry) {
      if (localeCountry.toLowerCase() === "uk") {
        localeCountry = "GB";
      }
      let foundCountry = countryOptions.find(
        (country) => country.code === localeCountry,
      );
      if (foundCountry) {
        reloadSweepstakesInfo(foundCountry);
        setFormData({
          ...formData,
          ...{ country: foundCountry },
        });
      }
    }
  }, []);

  let countryOptions = Settings.countryOptions;
  const countries_fr = Settings.countries_fr;
  const countries_de = Settings.countries_de;

  if (i18n.language === "fr-FR") {
    // Map French names to countryOption Labels
    for (var i = 0; i < countryOptions.length; i++) {
      countryOptions[i].lab = countries_fr[i];
    }

    // Re-sort on label
    countryOptions = _.orderBy(countryOptions, ["lab"], ["asc", "desc"]);
  }

  if (i18n.language === "de-DE") {
    // Map German names to countryOption Labels
    for (var i = 0; i < countryOptions.length; i++) {
      countryOptions[i].lab = countries_de[i];
    }

    // Re-sort on label
    countryOptions = _.orderBy(countryOptions, ["lab"], ["asc", "desc"]);
  }

  /**
   * Get Google Analytics cookie
   * @return string|bool
   */
  const cookies = new Cookies();
  const getGoogleCookie = () => {
    var google_cookie = cookies.get("_ga");
    if (google_cookie) {
      return google_cookie;
    } else {
      return false;
    }
  };

  /**
   * Update form value in state
   * @param {string} key
   * @param {mixed} value
   * @return void
   */
  const updateFormValue = (key, value) => {
    var t = {};
    t[key] = value;
    // Have to do it like this as react won't re-render components if the same object is just updated
    setFormData({
      ...formData,
      ...t,
    });
  };

  /**
   * Reload sweepstakes info based on country selection
   * @return void
   */
  const reloadSweepstakesInfo = (country) => {
    setReloadingSweepstakesInfo(true);

    // Fetch all sweepstakes text from API
    API.getDictionaryAllLocales("sweepstakes_text").then((res) => {
      if (res && res?.items && res?.items[0]?.fields?.translation) {
        const translations = res.items[0].fields.translation;
        const countryLocale = LanguageTools.formatLocaleForContentful(country.locale);
        if (translations.hasOwnProperty(countryLocale)) {
          setSweepstakesText(translations[countryLocale]);
          setReloadingSweepstakesInfo(false);
        } else {
          setSweepstakesText("There was an error loading sweepstakes information");
          setReloadingSweepstakesInfo(false);
        }
      } else {
        setSweepstakesText("There was an error loading sweepstakes information");
        setReloadingSweepstakesInfo(false);
      }
    }).catch((e) => {
        console.error("Error fetching sweepstakes text from API", e);
        setSweepstakesText("There was an error loading sweepstakes information");
        setReloadingSweepstakesInfo(false);
    });


  }

  /**
   * Update country select value in state
   * @param {mixed} value
   * @return void
   */
  const updateFormCountry = (value) => {
    // Clear existing timeout
    if (countrySearchTimeoutRef.current) {
      clearTimeout(countrySearchTimeoutRef.current);
    }
    
    countrySearchTimeoutRef.current = setTimeout(() => {
      setCountrySearch("");
    }, 1000);
    
    setFormData({
      ...formData,
      country: value,
    });

    reloadSweepstakesInfo(value);
  };

  /**
   * Update state select value in state
   * @param {mixed} value
   * @return void
   */
  const updateFormState = (value) => {
    setFormData({
      ...formData,
      state: value,
    });
  };

  /**
   * Search countries for select input
   * @param {string} text
   * @return void
   */
  const searchCountries = React.useCallback((text) => {
  setCountrySearch(text);
}, []);
  //const searchCountries = (text) => {
  //  setCountrySearch(text);
  //};

  /**
   * Get filtered countries for select input
   * @return array
   */
  const filteredCountries = React.useMemo(() => {
  return _.filter(countryOptions, function (o) {
    return _.startsWith(_.toLower(o.lab), _.toLower(countrySearch));
  });
}, [countryOptions, countrySearch]);
  /*
  const getFilteredCountries = () => {
    console.log("get filter countries");
    var filtered = _.filter(countryOptions, function (o) {
      return _.startsWith(_.toLower(o.lab), _.toLower(countrySearch));
    });
    return filtered;
  };
  */

  const handleRecaptchaSuccess = () => {
    setRecaptcha(true);
  };

  const handleRecaptchaExpired = () => {
    setRecaptcha(false);
  };

  /**
   * Determine if we will/can redirect after successful submission based on Settings and handle the redirect
   * @return boolean
   */
  const willRedirectAfterSuccess = () => {
    if (
      SettingsDynamic.hasOwnProperty("post_vote_redirect_url") &&
      SettingsDynamic["post_vote_redirect_url"]
    ) {
      return true;
    }
    return false;
  }

  /**
   * Handle redirect after successful submission
   * if Settings.POST_VOTE_REDIRECT is true
   * @return void
   */
  const handleRedirectAfterSuccess = () => {
    if (
      willRedirectAfterSuccess()
    ) {
      window.location.href = SettingsDynamic["post_vote_redirect_url"];
    }
  };

  /**
   * Submit form data to API
   *
   * @return void
   */
  const submitForm = () => {
    if (validateForm()) {
      props.setSubmitting(true);

      // Add votes from state to formData
      var ballot = [];
      for (const [key, value] of Object.entries(props.votes)) {
        if (value.id) {
          ballot.push({
            categoryName: key,
            productName: value.id,
          });
        }
      }

      // Prepare data for submission
      var submitData = {
        ...formData,
        ballot: ballot,
        "g-recaptcha-response": recaptchaRef.current.getValue(),
        market: i18n.language,
      };

      submitData.country = formData.country.value;
      // Only submit state if country is US as it's only relevant for that market
      if (formData.country.value === "United States") {
        submitData.state = formData.state.value;
      }

      // Add GA user id if available
      var ga_user_id = getGoogleCookie();
      if (ga_user_id) {
        submitData["user_id"] = ga_user_id;
      }

      //console.log(submitData)

      // Submit to API
      API.submitVotes(submitData)
        .then((res) => {
          Analytics.TrackCustom({
            event: "submitted_votes",
          });
          props.setSubmitting(false);

          if ([200, 201].includes(res.status)) {
            // show success
            props.setSuccess(true);
            // Submit custom vote events
            submitData.ballot.map(function (vote) {
              // send vote to datalayer
              Analytics.TrackCustom({
                event: "vote",
                categoryName: vote.categoryName,
                productName: vote.productName,
              });
            });
            props.submitVoted();
            handleRedirectAfterSuccess();
          } else if (res.status === 403) {
            // Handles voting closed as the visitor submits after the deadline
            Analytics.TrackCustom({
              event: "submitted_votes_failed",
            });
            setSubmissionError(true);
            try {
              res.json().then((data) => {
                if (data.hasOwnProperty("errors")) {
                  setSubmissionErrors(data.errors);
                }
              });
            } catch (e) {
              console.log("Error parsing submission error response");
            }
          } else {
            setSubmissionError(true);
            try {
              res.json().then((data) => {
                console.log(data);
                if (data.hasOwnProperty("errors")) {
                  setSubmissionErrors(data.errors);
                }
              });
            } catch (e) {
              console.log("Error parsing submission error response");
            }
          }
        })
        .catch((e) => {
          console.log("Submission error");
          console.error(e);
          props.setSubmitting(false);
          setSubmissionError(true);
        });

      // Submit form to api
      //setTimeout(
      //  () => {
      //    props.setSuccess(true)
      //  }, 1000
      //)
    } else {
      props.setSubmitting(false);
    }
  };

  /**
   * Disable submit button if form incomplete
   * @return bool
   */
  const disableSubmit = () => {
    if (
      formData.firstName &&
      formData.secondName &&
      formData.email &&
      formData.country &&
      formData.agreeTerms &&
      recaptcha
    ) {
      if (formData.country.value === "United States" && !formData.state.value) {
        return true;
      }
      return false;
    }
    return true;
  };

  /**
   * Determine if sweepstakes checkbox should be shown
   * @return bool
   */
  const showSweepstakes = () => {
    const show =
      formData?.country &&
      formData.country?.code &&
      props.sweepstakesInfo &&
      props.sweepstakesInfo.hasOwnProperty("countries") &&
      props.sweepstakesInfo.countries.includes(formData?.country?.code);
    return show;
  };

  /**
   * Validate email format
   * @param {string} email
   * @return bool
   */
  const validateEmail = (email) => {
    if (
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email,
      )
    ) {
      return true;
    }
    return false;
  };

  /**
   * Validate form data
   * @return bool
   */
  const validateForm = () => {
    var newErrors = {};

    if (!recaptcha) {
      newErrors["recaptcha"] = "Please check the reptcha box";
    }

    if (!formData["firstName"]) {
      newErrors["firstName"] = "Please enter your first name";
    }

    if (!formData["secondName"]) {
      newErrors["secondName"] = "Please enter your second name";
    }

    if (!formData["email"]) {
      newErrors["email"] = "Please enter your email";
    }

    if (!validateEmail(formData["email"])) {
      newErrors["email"] = "Please enter a valid email";
    }

    if (!formData["country"] || !formData["country"].value) {
      newErrors["country"] = "Please select your country";
    }

    if (
      formData.country.value === "United States" &&
      (!formData["state"] || !formData["state"].value)
    ) {
      newErrors["state"] = "Please select your state";
    }

    if (!formData["agreeTerms"]) {
      newErrors["agreeTerms"] = "Please agree to our terms and conditions";
    }

    setErrors(newErrors);
    if (_.keys(newErrors).length > 0) {
      return false;
    } else {
      return true;
    }
  };

  /**
   * Get error message for form field
   * @param {string} key
   * @return string|bool
   */
  const getError = (key) => {
    if (errors && errors.hasOwnProperty(key)) {
      return errors[key];
    } else {
      return false;
    }
  };

  /**
   * Render terms and conditions error
   * @return JSX.Element|void
   */
  const renderTermsError = () => {
    var e = getError("agreeTerms");
    if (e) {
      return (
        <p style={{ color: "red" }}>
          You must agree to our terms and conditions to submit your votes
        </p>
      );
    }
  };

  /**
   * Get sweepstakes text based on country selection and sweepstakes info from API
   * @return string
   */
  const getSweepstakesText = () => {
    if (sweepstakesText) {
      return sweepstakesText + " ";
    } else if (i18n.language === "en-EU") {
      return t("sweepstakes_text_eu") + " "
    } else {
      return t("sweepstakes_text") + " "
    }
  }

  /**
   * Get terms and conditions link based on country selection
   * @return string
   */
  const getTermsLink = () => {
    if (formData.country && formData.country.value) {
      if (LanguageTools.siteHasLocale(formData.country.locale)) {
      return `/${i18n.language}/terms-and-conditions?lang=${formData.country.locale}`
      } else {
        if (LanguageTools.localeIsEU(formData.country.locale)){
          return `/${i18n.language}/terms-and-conditions?lang=en-eu`
        }
        return `/${i18n.language}/terms-and-conditions?lang=${Settings.languageFallback}`
      }
    } else {
      return `/${i18n.language}/terms-and-conditions`
    }
  }

  /**
   * Get privacy policy link based on country selection
   * @return string
   */
  const getPrivacyLink = () => {
    if (formData.country && formData.country.value) {
      if (LanguageTools.siteHasLocale(formData.country.locale)) {
        return `/${i18n.language}/privacy-policy?lang=${formData.country.locale}`
      } else {
        if (LanguageTools.localeIsEU(formData.country?.locale)){
          return `/${i18n.language}/privacy-policy?lang=en-eu`
        }
        return `/${i18n.language}/privacy-policy?lang=${Settings.languageFallback}`
      }
    } else {
      return `/${i18n.language}/privacy-policy`
    }
  }

  /**
   * Render sweepstakes checkbox
   * @return JSX.Element|void
   */
  const renderSweepstakes = () => {
    if (showSweepstakes()) {

      if (reloadingSweepstakesInfo) {
        return (
          <Box pad={{ bottom: "10px" }}>
            <FontAwesomeIcon icon={faCog} spin />
          </Box>
        );
      }

      return (
        <CheckBox
          pad={{ bottom: "10px" }}
          checked={formData.enterSweepstake}
          label={
            <Box>
              <p style={{ margin: "0", fontSize: "12px" }}>
                {getSweepstakesText()}
                {/*
                <a
                  target="_blank"
                  style={{
                    color: "#fff",
                    textDecoration: "underline",
                    display: "inline",
                  }}
                  href={getTermsLink()}
                  target="_blank"
                >
                  {t("sweepstakes_hyperlink")}
                </a>
                */}
              </p>
            </Box>
          }
          onChange={(event) =>
            updateFormValue("enterSweepstake", event.target.checked)
          }
        />
      );
    }
  };

  /**
   * Render state selector
   * @return JSX.Element|void
   */
  const renderStateSelector = () => {
    if (formData.country && formData.country.value === "United States") {
      return (
        <FormField
          a11yTitle="State"
          name="state"
          htmlFor="state-input"
          error={getError("state")}
        >
          <Select
            placeholder={
              formData.state ? t(formData.state.lab) : t("Select your state")
            }
            options={Settings.USA_STATES}
            labelKey="lab"
            value={formData.state}
            onChange={({ option }) => updateFormState(option)}
          />
        </FormField>
      );
    }
  };

  /**
   * Render submission errors from server
   * @return JSX.Element
   */
  const renderSubmissionErrors = () => {
    console.log(submissionErrors);
    if (
      submissionErrors &&
      !Array.isArray(submissionErrors) &&
      typeof submissionErrors === "object"
    ) {
      // Flatten object errors into array
      return (
        <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
          {Object.values(submissionErrors)
            .flat()
            .map(function (error, index) {
              if (Array.isArray(error)) {
                error.forEach(function (e) {
                  return (
                    <li key={index}>
                      <p style={{ textAlign: "center", color: "white" }}>{e}</p>
                    </li>
                  );
                });
              } else {
                return (
                  <li key={index}>
                    <p style={{ textAlign: "center", color: "white" }}>
                      {error}
                    </p>
                  </li>
                );
              }
            })}
        </ul>
      );
    } else if (
      submissionErrors &&
      Array.isArray(submissionErrors) &&
      submissionErrors.hasOwnProperty("map")
    ) {
      return (
        <ul style={{ listStyleType: "none", paddingLeft: "0px" }}>
          {submissionErrors.map(function (error, index) {
            return (
              <li key={index}>
                <p style={{ textAlign: "center", color: "white" }}>{error}</p>
              </li>
            );
          })}
        </ul>
      );
    } else {
      // Show generic error msg
      return (
        <p style={{ color: "white" }}>
          We do apologise but something seems to have gone wrong
        </p>
      );
    }
  };

  /**
   * Render form content based on state
   * @return JSX.Element
   */
  const renderForm = () => {
    if (props.success) {
      if (willRedirectAfterSuccess()) {
        return (
          <div className="cog">
            <FontAwesomeIcon icon={faCog} spin />
          </div>
        );
      }
      return <Box></Box>;
    } else if (votingClosed) {
      return (
        <Box className="submissionError">
          <p>Voting Closed</p>
          <Button
            primary
            label="Try again"
            onClick={() => {
              setSubmissionError(false);
              setSubmissionErrors([]);
              setVotingClosed(false);
            }}
          />
        </Box>
      );
    } else if (submissionError) {
      return (
        <Box className="submissionError">
          {renderSubmissionErrors()}
          <Button
            primary
            label="Try again"
            onClick={() => {
              setSubmissionError(false);
              setSubmissionErrors([]);
            }}
          />
        </Box>
      );
    } else if (props.submitting) {
      return (
        <div className="cog">
          <FontAwesomeIcon icon={faCog} spin />
        </div>
      );
    } else {
      return (
        <>
          {/**<pre style={{color: "#000"}}>{JSON.stringify(formData)}</pre>**/}
          <FormField
            a11yTitle={t("First Name")}
            htmlFor="first-name-input"
            error={getError("firstName")}
          >
            <TextInput
              value={formData.firstName}
              onChange={(event) =>
                updateFormValue("firstName", event.target.value)
              }
              id="first-name-input"
              placeholder={t("First Name")}
            />
          </FormField>
          <FormField
            a11yTitle={t("Second Name")}
            htmlFor="second-name-input"
            error={getError("secondName")}
          >
            <TextInput
              value={formData.secondName}
              onChange={(event) =>
                updateFormValue("secondName", event.target.value)
              }
              placeholder={t("Second Name")}
              id="second-name-input"
            />
          </FormField>
          <FormField
            a11yTitle={t("Email Address")}
            htmlFor="email-input"
            error={getError("email")}
          >
            <TextInput
              value={formData.email}
              onChange={(event) => updateFormValue("email", event.target.value)}
              placeholder={t("Email Address")}
              id="email-input"
              name="email"
              type="email"
            />
          </FormField>
          <FormField
            a11yTitle="Country"
            name="country"
            htmlFor="country-input"
            error={getError("country")}
          >
            <Select
              placeholder={
                formData.country
                  ? t(formData.country.lab)
                  : t("select your country?")
              }
              options={filteredCountries}
              labelKey="lab"
              valueKey={{ key: "value", reduce: false }} // <-- Add this to stabilize value matching
              value={formData.country}
              onChange={({ option }) => updateFormCountry(option)}
              //onSearch={searchCountries}
              onClose={() => {
                // Don't clear search immediately on close
              }}
            />
          </FormField>
          {renderStateSelector()}
          {renderSweepstakes()}
          <CheckBox
            checked={formData.emailOptIn}
            pad={{ bottom: "10px" }}
            label={
              <p style={{ margin: "0px", fontSize: "12px" }}>
                {t("Receive News and Updates from MPB?")}
              </p>
            }
            onChange={(event) =>
              updateFormValue("emailOptIn", event.target.checked)
            }
          />
          <CheckBox
            checked={formData.agreeTerms}
            pad={{ bottom: "10px" }}
            label=""
            label={
              <Box>
                <p style={{ margin: "0px", fontSize: "12px" }}>
                  {t("I have read and accepted the")}{" "}
                  <Link
                    style={{ color: "#fff", display: "inline" }}
                    to={getTermsLink()}
                    target="_blank"
                  >
                    {" "}
                    {t("Terms & Conditions")}
                  </Link>{" "}
                  /{" "}
                  <Link
                    style={{ color: "#fff", display: "inline" }}
                    to={getPrivacyLink()}
                    target="_blank"
                  >
                    {" "}
                    {t("Privacy Policy")}
                  </Link>
                </p>
              </Box>
            }
            onChange={(event) =>
              updateFormValue("agreeTerms", event.target.checked)
            }
          />
          {renderTermsError()}
          <Box
            style={{ marginTop: "10px" }}
            direction="column"
            gap="small"
            align="center"
          >
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={Settings.RECAPTCHA_SITE_KEY}
              onChange={handleRecaptchaSuccess}
              onExpired={handleRecaptchaExpired}
            />
          </Box>
          <Box
            style={['xsmall','small'].includes(screenSize) ? {} : { marginTop: "10px" }}
            direction={['xsmall','small'].includes(screenSize) ? 'column' : 'row'}
            gap="small"
            justify="between"
            align={['xsmall','small'].includes(screenSize) ? 'center' : ''}
          >
            <Button
              style={{ width: "50%" }}
              secondary
              label={t("edit votes")}
              onClick={() => {
                props.setShowProducts(true);
                props.setVoteStep(1);
              }}
            />
            <Button
              style={{ width: "50%" }}
              primary
              label={t("submit")}
              disabled={disableSubmit()}
              onClick={() => submitForm()}
            />
          </Box>
        </>
      );
    }
  };

  /**
   * Render heading based on state
   * @return string
   */
  const renderHeading = () => {
    if (submissionError) {
      return t("Oops, something went wrong");
    } else if (props.success) {
      if (willRedirectAfterSuccess()) {
        return t("Submitting your votes");
      }
      return t("Your votes have been recorded");
    } else if (props.submitting) {
      return t("Submitting your votes");
    } else {
      return t("Submit your votes");
    }
  };

  /**
   * Render return to site button
   * @return JSX.Element|void
   */
  const renderReturnToSiteButton = () => {
    if (props.success) {
      if (willRedirectAfterSuccess()) {
        return null;
      }
      return (
        <div
          style={{
            display: "flex",
            gap: "20px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <Button
            primary
            label={t("Return to the site")}
            onClick={() => {
              props.setVoteStep(1);
              props.setShowProducts(true);
              props.setIsToggled(false);
            }}
          />
          <Button
            primary
            label={t("Explore MPB")}
            href="https://www.mpb.com?utm_source=halloffame&utm_medium=referral&utm_campaign=hof2023"
            target="_blank"
          />
        </div>
      );
    } else {
      return null;
    }
  };

  /**
   * Render social share buttons
   * @return JSX.Element|void
   */
  const renderSocialShareButtons = () => {
    if (props.success) {
      if (willRedirectAfterSuccess()) {
        return null;
      }
      return (
        <div className="socialShare">
          <span>{t("Share on social media")}</span>
          <a
            className="icon fb"
            target="_blank"
            href="https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fmpb.com/hall-of-fame"
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
          {/**
        <a className="icon ig" target="_blank" href="#">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        **/}
          {/**
        <a className="icon tw" target="_blank" href="https://twitter.com/intent/tweet/?text=I%20voted%20for%20the%20best%20photo%20and%20video%20kit%20of%20the%20digital%20age%20at%20kithallfofame.com&amp;url=https%3A%2F%2Fmpb.com/hall-of-fame">
          <FontAwesomeIcon icon={faTwitter} />
        </a>
        **/}
          <a
            className="icon email"
            href="mailto:?subject=I%20voted%20for%20the%20best%20photo%20and%20video%20kit%20of%20the%20digital%20age%20at%20mpb.com/hall-of-fame&amp;body=https%3A%2F%2Fmpb.com/hall-of-fame"
            target="_self"
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <Box
      id="voteForm"
      className="transitionFadeInFast"
      flex={true}
      pad="medium"
      align="center"
      justify="center"
      overflow="auto"
    >
      {props.renderCloseButton()}
      <Box flex={true} align="center" justify="center" width="large">
        <Heading level={3} margin="none">
          {renderHeading()}
        </Heading>
        <Box
          style={{ display: "block" }}
          pad={{ top: "medium", bottom: "medium" }}
          gap="small"
        >
          {renderForm()}
          {renderSocialShareButtons()}
          {renderReturnToSiteButton()}
        </Box>
      </Box>
    </Box>
  );
};

const VoteProduct = ({
  t,
  match,
  setIsToggled,
  title,
  product,
  removeVote,
  setCategories,
  category_id,
  category,
}) => {
  const getCategoryImage = () => {
    if (category && category.hasOwnProperty("imageSmall")) {
      return (
        <img
          className="categoryImage"
          //fit="contain"
          alt={category.name}
          src={category.imageSmall.fields.file.url}
        />
      );
    } else {
      return <p>no category image</p>;
    }
  };

  if (!product) {
    return (
      <Box
        className="cartProduct"
        align="center"
      >
        <Box className="cartProductBox" round="small">
          {getCategoryImage()}
          <Box
            flex="grow"
            width="xsmall"
            border={{
              color: "primary",
              size: "5px",
              style: "dotted",
              side: "all",
            }}
            style={{
              justifyContent: "center",
              alignItems: "center",
              zIndex: "101",
            }}
          >
            <Link
              to={`${match.url}?category=${category_id}#nominees`}
              onClick={() => {
                setIsToggled();
                scrollToID("productsAnchor");
              }}
            >
              <Button
                Primary
                className="cartProductVote"
                label={t("vote")}
              ></Button>
            </Link>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box className="cartProduct hasVote" align="center">
        <Tip
          content={
            <div className="productTip">
              {t("You’re voting for the")} {product.name}
            </div>
          }
          plain={true}
        >
          <Box className="cartProductBox" round="small">
            {getCategoryImage()}
            <Box className="titleBar" flex direction="row" align="end">
              <button
                className="modalClose"
                onClick={() => {
                  removeVote(category_id);
                }}
              >
                <FontAwesomeIcon icon={faTimesCircle} />
              </button>
            </Box>
            <Box
              //flex="grow"
              //height="xsmall"
              style={{
                width: "100%",
                height: "100%",
                //height: "100px",
                borderRadius: "4px",
                overflow: "hidden",
                backgroundImage: `url(${product.image.fields.file.url})`,
                backgroundSize: "cover",
                backgroundPosition: "center right",
              }}
            ></Box>
          </Box>
        </Tip>
      </Box>
    );
  }
};

const VoteCart = (props) => {
  const { t, i18n, match, votes, voted, categories } = props;
  const size = useWindowSize();
  const [isToggled, setIsToggled] = useState(false); // Open voting
  const [isMinimised, setIsMinimised] = useState(true); // Will show a smaller version if minimised
  const [submitting, setSubmitting] = useState(false); // Open voting
  const [success, setSuccess] = useState(false); // Open voting
  const [voteStep, setVoteStep] = useState(1); // Show last chance or form
  const [showProducts, setShowProducts] = useState(true);
  const [sweepstakesInfo, setSweepstakesInfo] = useState(false);

  const history = useHistory();
  // Settings from state
  const SettingsDynamic = useSelector((state) => state.settings);

  // Initial load
  useEffect(() => {
    // Get Sweepatakes info from API
    API.getSweepstakesInfo()
      .then((res) => {
        res.json().then((data) => {
          setSweepstakesInfo(data);
        });
      })
      .catch(console.error);
  }, []);

  // runs when categories change
  useEffect(() => {
    if (categories && !categories.updated) {
      API.getCategories(i18n)
        .then((res) => {
          // Set categories in state
          var now = new Date();
          var categories = {
            updated: now.toJSON(), // Set with date/time when updated
          };
          res.items.forEach((category) => {
            categories[category.fields.id] = _.omit(category.fields, [
              "products",
            ]);
          });

          props.setCategories(categories);
        })
        .catch(console.error);
    }
  }, [categories]);

  /**
   * Determine if vote cart should be shown based on settings and if user has votes
   * @return bool
   */
  const checkVisibility = () => {
    if (
      !Settings.FAKE_VOTING &&
      (
        !Settings.GetDynamicBool(SettingsDynamic, "allow_voting", Settings.ALLOW_VOTING) ||
        Settings.GetDynamicBool(SettingsDynamic, "voting_closed", Settings.VOTING_CLOSED)
      )
    ) {
      return false;
    }
    if (
      props.votes["classic"] ||
      props.votes["game-changer"] ||
      props.votes["road-tested"] ||
      props.votes["trendsetter"] ||
      props.votes["iconic"]
    ) {
      return true;
    } else {
      return false;
    }
  };

  /** 
   * Return the voting form component if isToggled is true
   * @return JSX.Element|void
   */
  const showVoteForm = () => {
    if (isToggled) {
      return (
        <VoteForm
          setShowProducts={setShowProducts}
          setVoteStep={setVoteStep}
          voteStep={voteStep}
          votes={votes}
          setIsToggled={setIsToggled}
          submitting={submitting}
          setSubmitting={setSubmitting}
          success={success}
          setSuccess={setSuccess}
          submitVoted={props.submitVoted}
          renderCloseButton={renderCloseButton}
          sweepstakesInfo={sweepstakesInfo}
          t={t}
          i18n={i18n}
        />
      );
    } else {
      return null;
    }
  };

  const countVotes = () => {
    var nonEmptyVotes = _.pickBy(props.votes, _.identity);
    var count = _.keys(nonEmptyVotes).length;
    return count;
  };

  const allVotesReady = () => {
    // True if all 5 votes are selected
    if (countVotes() == 5) {
      return true;
    } else {
      return false;
    }
  };

  // #TODO - use reactspring trails e.g. https://codesandbox.io/s/49jsc?file=/src/index.js
  const slideUp = useSpring({
    //opacity: checkVisibility() ? '1' : '0',
    height: checkVisibility()
      ? isToggled
        ? size.height + "px"
        : isMinimised
          ? size.height > 500
            ? "73px"
            : "50px"
          : "30%"
      : "0px",
    //color: isToggled ? '#000' : 'red',
    //transform: isToggled
    //  ? 'translate3d(0, 30px, 0)'
    //  : 'translate3d(0, 30px, 0)',
    //fontSize: isToggled ? '2rem' : '3rem',
  });

  const voteStatusSpring = useSpring({
    width: countVotes() * (100 / 5) + "%",
    //backgroundColor: allVotesReady() ? "#e4eadf" : "#f8d44c"
  });

  const springLastChance = useSpring({
    //config: { friction: 100 },
    //opacity: submitting ? '0' : '1',
    //marginTop: submitting ? '-500px' : '0px',
    //background: showProducts ? "linear-gradient(90deg, #140D40 0%, #331339 50%, #501933 100%)" : "linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, #FFFFFF 100%)",
    //height: checkVisibility() ? isToggled ? '100%' : isMinimised ? '10%' : '30%' : '0%',
  });

  const fadeLastChance = useSpring({
    opacity: showProducts ? "1" : "0",
  });

  const voteIndicatorSpring = useSpring({
    to: { opacity: 1, transform: "scale(1)" },
    from: { opacity: 0, transform: "scale(0.1)" },
  });

  const trail = useTrail(5, {
    //config: {
    //  tension: 200,
    //  friction: 13,
    //  velocity: 30
    //},
    config: {
      tension: 180,
      friction: 12,
    },
    //opacity: isToggled ? 1 : 0.5,
    //transform: isToggled && showProducts ? 'translate3d(0,0px,0) scale(1)' : 'translate3d(0,120px,0) scale(0.2)',
    transform: isToggled && showProducts ? "scale(1)" : "scale(0.2)",
  });

  // Toggle minimised version
  const minimise = () => {
    setIsMinimised(true);
  };

  const unminimise = () => {
    setIsMinimised(false);
  };

  // Toggle display of viting form
  const toggle = () => {
    if (!isToggled) {
      Analytics.TrackPageView("Vote Cart", "/vote-cart");
    }

    setIsToggled(!isToggled);
  };

  const renderVotedDate = (date) => {
    var d = new Date(date);
    return d.toLocaleString();
  };

  const renderVoteProducts = () => {
    return (
      <Box className="ballot">
        {trail.map((props2, index) => {
          //var cat =
          return (
            <animated.div key={index} style={props2} className="box">
              {index == 0 ? (
                <VoteProduct
                  t={t}
                  match={match}
                  setIsToggled={setIsToggled}
                  title="Classic"
                  product={props.votes["classic"]}
                  category_id={"classic"}
                  removeVote={removeVote}
                  category={categories["classic"]}
                />
              ) : null}
              {index == 1 ? (
                <VoteProduct
                  t={t}
                  match={match}
                  setIsToggled={setIsToggled}
                  title="Game Changer"
                  product={props.votes["game-changer"]}
                  category_id={"game-changer"}
                  removeVote={removeVote}
                  category={categories["game-changer"]}
                />
              ) : null}
              {index == 2 ? (
                <VoteProduct
                  t={t}
                  match={match}
                  setIsToggled={setIsToggled}
                  title="Road Tested"
                  product={props.votes["road-tested"]}
                  category_id={"road-tested"}
                  removeVote={removeVote}
                  category={categories["road-tested"]}
                />
              ) : null}
              {index == 3 ? (
                <VoteProduct
                  t={t}
                  match={match}
                  setIsToggled={setIsToggled}
                  title="Trendsetter"
                  product={props.votes["trendsetter"]}
                  category_id={"trendsetter"}
                  removeVote={removeVote}
                  category={categories["trendsetter"]}
                />
              ) : null}
              {index == 4 ? (
                <VoteProduct
                  t={t}
                  match={match}
                  setIsToggled={setIsToggled}
                  title="Iconic"
                  product={props.votes["iconic"]}
                  category_id={"iconic"}
                  removeVote={removeVote}
                  category={categories["iconic"]}
                />
              ) : null}
            </animated.div>
          );
        })}

        {/**
          <VoteProduct match={match} setIsToggled={setIsToggled} title="Classic" product={props.votes['classic']} category_id={'classic'} removeVote={removeVote} category={categories['classic']} />
          <VoteProduct match={match} setIsToggled={setIsToggled} title="Game Changer" product={props.votes['game-changer']} category_id={'game-changers'} removeVote={removeVote} category={categories['game-changers']} />
          <VoteProduct match={match} setIsToggled={setIsToggled} title="Road Tested" product={props.votes['road-tested']} category_id={'road-tested'} removeVote={removeVote} category={categories['road-tested']} />
          <VoteProduct match={match} setIsToggled={setIsToggled} title="Trendsetter" product={props.votes['trendsetter']} category_id={'trendsetter'} removeVote={removeVote} category={categories['trendsetter']} />
          <VoteProduct match={match} setIsToggled={setIsToggled} title="Iconic" product={props.votes['iconic']} category_id={'iconic'} removeVote={removeVote} category={categories['iconic']} />
           **/}
      </Box>
    );
  };

  const renderVoteStatus = () => {
    if (isToggled) {
      if (voteStep === 1) {
        // show last chance
        return (
          <animated.div style={springLastChance} className="lastChance delay-6">
            <animated.h3 style={fadeLastChance}>
              {allVotesReady()
                ? t("Your Votes")
                : t("Last chance to cast your remaining votes")}
            </animated.h3>
            {renderVoteProducts()}
            <animated.div style={fadeLastChance}>
              <Box direction="row" justify="center">
                <Button
                  className="buttonYellow cartButton cartButtonLeft"
                  primary
                  label={t("Keep Voting")}
                  onClick={() => setIsToggled()}
                />
                <Button
                  className="buttonYellow cartButton cartButtonLeft"
                  primary
                  label={t("Submit Votes")}
                  onClick={() => {
                    setShowProducts(false);
                    setTimeout(() => {
                      Analytics.TrackPageView(
                        "Vote Form",
                        "/vote-submission-form",
                      );
                      setVoteStep(2);
                    }, 300);
                  }}
                />
              </Box>
            </animated.div>
          </animated.div>
        );
      } else {
        return null;
      }
    } else {
      if (voted) {
        return (
          <Box
            id="voteCartInner"
            direction="column"
            justify="center"
            align="center"
          >
            <h3>
              {t("You voted successfully on")} {renderVotedDate(voted)}
            </h3>
          </Box>
        );
      } else {
        return (
          <Box
            id="voteCartInner"
            direction="column"
            justify="between"
            align="center"
          >
            <Box direction="row" justify="center" id="voteIndicators">
              {renderVoteCheckboxes()}
            </Box>

            <h3>
              <span>{countVotes()}</span> {t("out of")} 5 {t("votes")}{" "}
            </h3>

            <Box
              className="cartButtonContainer"
              direction="row"
              justify="center"
            >
              {renderBallotButton()}
            </Box>
            <animated.div
              style={voteStatusSpring}
              id="voteCartStatus"
            ></animated.div>
          </Box>
        );
      }
    }
  };

  const getCategoryImage = (cat) => {
    if (
      categories &&
      categories.hasOwnProperty(cat) &&
      categories[cat].hasOwnProperty("imageSmall")
    ) {
      return (
        <img
          className="categoryImage"
          //fit="contain"
          alt={categories[cat].name}
          src={categories[cat].imageSmall.fields.file.url}
        />
      );
    } else {
      return <p>no category image</p>;
    }
  };

  // Voting
  const removeVote = (category_id) => {
    if (countVotes() === 1) {
      setIsToggled(false); // close cart if no votes
    }
    // remove vote from state
    props.removeVote(category_id);
  };

  const renderVoteCheckboxes = () => {
    var have_votes = _.omitBy(props.votes, _.isEmpty);
    var no_votes = _.pickBy(props.votes, _.isEmpty);
    var votes = _.merge(have_votes, no_votes);
    return Object.keys(votes).map((keyName, i) => {
      if (votes[keyName]) {
        return (
          <Tip
            key={i}
            content={<div className="voteTip">{getCategoryImage(keyName)}</div>}
            plain={true}
          >
            <div
              key={keyName}
              title={keyName}
              className="voteIndicator voteIndicatorYes"
              onClick={() => {
                history.push(`${match.url}?category=${keyName}#nominees`);
                scrollToID("productsAnchor");
              }}
            >
              <FontAwesomeIcon icon={faCheck} />
            </div>
          </Tip>
        );
      } else {
        return (
          <Tip
            key={i}
            content={<div className="voteTip">{getCategoryImage(keyName)}</div>}
            plain={true}
          >
            <div
              key={keyName}
              title={keyName}
              className="voteIndicator voteIndicatorNo"
              onClick={() => {
                history.push(`${match.url}?category=${keyName}#nominees`);
                scrollToID("productsAnchor");
              }}
            ></div>
          </Tip>
        );
      }
    });
  };

  const renderBallotButton = () => {
    if (!isToggled) {
      return (
        <Button
          className={
            allVotesReady()
              ? "pulse-purple buttonBlue cartButtoncart cartButtonRight"
              : "buttonPurple cartButtoncart cartButtonRight"
          }
          primary
          label={t("cast ballot")}
          onClick={() => {
            toggle();
          }}
        />
      );
    } else {
      return null;
    }
  };

  const renderMinimiseButton = () => {
    if (!isToggled) {
      if (isMinimised) {
        return (
          <Button
            className="buttonYellow cartButton cartButtonLeft"
            primary
            label="Expand"
            onClick={() => unminimise()}
          />
        );
      } else {
        return (
          <Button
            className="buttonYellow cartButton cartButtonLeft"
            primary
            label="Minimise"
            onClick={() => minimise()}
          />
        );
      }
    } else {
      return (
        <Button
          className="buttonYellow cartButton cartButtonLeft"
          primary
          label={t("Keep Voting")}
          onClick={() => toggle()}
        />
      );
    }
  };

  const renderCloseButton = () => {
    if (isToggled) {
      return (
        <button
          className="modalClose"
          onClick={() => {
            setVoteStep(1);
            setShowProducts(true);
            setIsToggled(false);
          }}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>
      );
    } else {
      return null;
    }
  };

  if (false) {
    return null;
  } else {
    return (
      <animated.div
        id="voteCart"
        className={
          " " +
          (isMinimised ? "voteCartMinimised " : " ") +
          (isToggled ? "voteCartToggled " : " ")
        }
        style={{
          display: checkVisibility() ? "flex" : "none",
          flexDirection: "column",
          align: "center",
          flex: "0 0 auto",
          height: "300px",
          width: "100%",
          color: "#fff",
          backgroundColor: "#fff",
          ...slideUp,
        }}
      >
        {voteStep === 1 ? (
          <div id="voteCartBackground" style={{ flexGrow: 1 }}>
            {renderCloseButton()}
            {renderVoteStatus()}
          </div>
        ) : null}
        {voteStep === 2 ? showVoteForm() : null}
      </animated.div>
    );
  }
};

// Map redux state to props (remember to export below with this function)
const mapStateToProps = (state) => {
  return {
    votes: state.cart.votes,
    voted: state.cart.voted,
    categories: state.cart.categories,
  };
};

// Map redux dispatches to props (remember to export below with this function)
const mapDispatchToProps = (dispatch) => {
  return {
    removeVote: (category_id) => {
      dispatch(removeVote(category_id));
    },
    setCategories: (categories) => {
      dispatch(setCategories(categories));
    },
    submitVoted: () => {
      dispatch(submitVoted());
    },
  };
};

// Using null as first argument as no mapStateToProps (https://stackoverflow.com/questions/35443167/dispatch-is-not-a-function-when-argument-to-maptodispatchtoprops-in-redux)
export default connect(mapStateToProps, mapDispatchToProps)(VoteCart);
